import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from "react";
import iconSizes from "../iconSizes";
import { deprecatedPropValueMessage } from "../../../utils/deprecationUtils";
var isDeprecatedIconSize = function(iconSize) {
    if (typeof iconSize === 'undefined') {
        return false;
    }
    return iconSize === 'xl';
};
var CopyIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 's' : _size, _color = param.color, color = _color === void 0 ? 'currentColor' : _color, title = param.title;
    if (isDeprecatedIconSize(size)) {
        deprecatedPropValueMessage({
            componentName: 'Icon',
            propName: 'size',
            propValue: 'xl',
            date: 'Q3 2022'
        });
    }
    var ref;
    return _jsxs("svg", {
        focusable: "false",
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: '0 0 32 32',
        css: {
            width: iconSizes[size],
            height: iconSizes[size],
            fill: color
        },
        role: "img",
        "aria-hidden": (ref = !title) !== null && ref !== void 0 ? ref : false,
        children: [
            title && _jsx("title", {
                children: title
            }),
            _jsx("g", {
                children: _jsx("svg", {
                    viewBox: "0 0 24 24",
                    children: _jsx("path", {
                        d: "M22 5.188A3.188 3.188 0 0018.812 2H9.188A3.187 3.187 0 006 5.188V6h-.813A3.187 3.187 0 002 9.188v9.624A3.188 3.188 0 005.188 22h9.625A3.188 3.188 0 0018 18.812V18h.813A3.188 3.188 0 0022 14.812V5.188zm-4 10.687h.813c.586 0 1.062-.476 1.062-1.063V5.188c0-.587-.476-1.063-1.063-1.063H9.188c-.586 0-1.062.476-1.062 1.063V6h6.688A3.188 3.188 0 0118 9.188v6.687zM5.187 8.125c-.586 0-1.062.476-1.062 1.063v9.624c0 .587.476 1.063 1.063 1.063h9.625c.586 0 1.062-.476 1.062-1.063V9.188c0-.586-.476-1.062-1.063-1.062H5.188z",
                        fillRule: "evenodd",
                        clipRule: "evenodd"
                    })
                })
            })
        ]
    });
};
CopyIcon.isCarinaIcon = true;
export default CopyIcon;
